<template>
  <div class="sidebar">
    <!-- <img src="../../assets/logo.png" class="logo" alt="" /> -->

    <!-- 左上角返回工作台按钮 -->
    <div class="back-workbench-btn" @click="goToWorkbench">
      <span class="icon">←</span>
      <span class="text">返回工作台</span>
    </div>

    <el-menu
      class="el-menu-vertical-demo"
      v-bind:uniqueOpened="true"
      :default-active="$store.getters.menuTitle"
      v-on:select="select"
      background-color="#333333"
      text-color="#fff"
      active-text-color="#ffd04b" >

      <div :key="menu.url" v-for="menu in menuData">
        <el-submenu v-bind:index="menu.url" v-if="menu.hasSubMenu">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>{{ menu.menuName }}</span>
          </template>
          <el-menu-item-group :key="subMenu.menuId" v-for="(subMenu,index2) in menu.subMenuList">
            <el-menu-item v-bind:index="subMenu.url">{{ subMenu.menuName }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-menu-item v-bind:index="menu.url"  v-else>
          <i v-bind:class="menu.icon"></i>
          <span slot="title">{{ menu.menuName }}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: "SideBar",
  data() {
    return {
      menuData : [
        {
          menuId: 11,
          menuName: "菜单名称",
          icon: "",
          url:"homeTotal",
          hasSubMenu: false,
          subMenuList:[]
        }
      ]
    }
  },
  mounted() {
    this.initMenu()
  },
  methods: {
    initMenu(){
      let menuData = JSON.parse(localStorage.getItem("vmsMenuData"))
      this.menuData = menuData

      // this.select("activityManage")
    },
    select(key) {
      this.$store.commit("setMenuTitle", key);
      this.$router.push({ path: `/vms/${key}`, query: { ut: Date.now() } });
    },
    goToWorkbench() {
      window.location.replace("https://uat.lingshutong.cn/#/desktop")
    },
  }
};
</script>
<style lang="sass" scoped>
  .sidebar
    width: 200px
    height: 100%
    position: fixed
    background: #272727
  .el-menu
    border-right: 0
  .logo
    width: 100%

  .back-workbench-btn
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    color: #fff;
    cursor: pointer;
    border-bottom: 1px solid #333; /* 加一条分隔线，和下面的菜单区分开 */
    transition: background 0.2s;

  .back-workbench-btn:hover
    background: #333;

  .back-workbench-btn .icon
    font-size: 18px;

  .back-workbench-btn .text
    font-size: 18px;


</style>





// WEBPACK FOOTER //
// src/vms/pages/layout/SideBar.vue